// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c8a946d7c0c970455a45","655":"0639f02ebc663d7ec0b6"}[chunkId] + ".js";
};